import React, { Component } from 'react';
import { Switch, Link, Route } from 'react-router-dom'
import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import AddNewContainer from '../Components/AddNew/AddNewContainer';
import EditNewContainer from '../Components/AddNew/EditNewContainer';
import AddNewCo from '../Components/Department/CO/AddNewCo';
import EditNewCo from '../Components/Department/CO/EditNewCo';
import CoLanding from '../Components/Department/CO/CoLanding';
import AddNewActivity from '../Components/Department/Activity/AddNewActivity';
import ActivityLanding from '../Components/Department/Activity/ActivityLanding';
import EditNewActivity from '../Components/Department/Activity/EditNewActivity';
import AddFacilityActivity from '../Components/Department/Facility/AddFacilityActivity';
import EditNewFacility from '../Components/Department/Facility/EditNewFacility';
import FacilityLanding from '../Components/Department/Facility/FacilityLanding';
import AddIqacFileGroup from '../Components/Iqac/Facility/AddIqacFileGroup';
import EditIqacFileGroup from '../Components/Iqac/Facility/EditIqacFileGroup';
import IqacFileGroupLanding from '../Components/Iqac/Facility/IqacFileGroupLanding';
import AddIqacFileItem from '../Components/Iqac/FileItem/AddIqacFileItem';
import EditIqacFileItem from '../Components/Iqac/FileItem/EditIqacFileItem';
import IqacFileItemLanding from '../Components/Iqac/FileItem/IqacFileItemLanding';

class AddNewContainerMain extends Component {
    constructor(props) {
        super(props);

        let user = JSON.parse(localStorage.getItem('user'));


        this.state = {
            apikey: user.user.apikey,
            username: user.user.email,
            name: user.user.name,
            role: user.user.name
        }

    }

    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">

                    <Switch>
                        <Route exact path="/notices" render={(props) =>
                            <AddNewContainer
                                {...props}
                                history={this.props.history}
                                title="Notification"
                                code="notice"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/tender" render={(props) =>
                            <AddNewContainer
                                {...props}
                                history={this.props.history}
                                title="Tender"
                                code="tender"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/news" render={(props) =>
                            <AddNewContainer
                                {...props}
                                history={this.props.history}
                                title="News"
                                code="news"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/events" render={(props) =>
                            <AddNewContainer
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/edit" render={(props) =>
                            <EditNewContainer
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />



                        <Route exact path="/courseoutcome/add" render={(props) =>
                            <AddNewCo
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/courseoutcome/edit" render={(props) =>
                            <EditNewCo
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/courseoutcome/view" render={(props) =>
                            <CoLanding
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/activity/add" render={(props) =>
                            <AddNewActivity
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/activity/edit" render={(props) =>
                            <EditNewActivity
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/activity/view" render={(props) =>
                            <ActivityLanding
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />


                        <Route exact path="/facility/add" render={(props) =>
                            <AddFacilityActivity
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/facility/edit" render={(props) =>
                            <EditNewFacility
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/facility/view" render={(props) =>
                            <FacilityLanding
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />



<Route exact path="/filegroup/add" render={(props) =>
                            <AddIqacFileGroup
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/filegroup/edit" render={(props) =>
                            <EditIqacFileGroup
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/filegroup/view" render={(props) =>
                            <IqacFileGroupLanding
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />


<Route exact path="/filegroupitem/add" render={(props) =>
                            <AddIqacFileItem
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/filegroupitem/edit" render={(props) =>
                            <EditIqacFileItem
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/filegroupitem/view" render={(props) =>
                            <IqacFileItemLanding
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />
                    </Switch>



                </div>
            </div>
        )
    }
}

export default withAuth(AddNewContainerMain);


// WEBPACK FOOTER //
// ./src/Containers/AddNewContainerMain.js